import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';
import { AgResourceLanguage } from '../types';

export const modalWindows: AgResourceLanguage['modalWindows'] = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Modifier la méthode de livraison',
    subtitle: 'Choisissez :',
    saveMethodButton: 'Enregistrer la méthode de livraison'
  },
  editShippingAddress: {
    bannerText: "L'adresse de livraison sera modifiée à partir de la prochaine expédition",
    titleHeaderCreate: 'Créer une adresse de livraison',
    subscriptionUpdate: 'Définir comme adresse de livraison pour mon abonnement',
    address2: 'Appartement, Suite, Etc. (facultatif)',
    city: 'Ville',
    usedSavedLabel: 'Utiliser l’adresse enregistrée',
    zip: 'Code postal',
    titleAddress: 'Modifier l’adresse',
    titleHeaderEdit: 'Modifier l’adresse de livraison',
    last_name: 'Nom de famille',
    company: 'Entreprise (facultatif)',
    first_name: 'Prénom',
    phone: 'Téléphone',
    province: 'Province',
    deleteAddressText: 'Êtes-vous sûr de vouloir supprimer l’adresse enregistrée ?',
    selectAddress: {
      reloadMessage: 'Veuillez recharger la page',
      noSavedAddressText: "Vous n'avez actuellement aucune adresse enregistrée",
      useSavedAddressButton: 'Utiliser l’adresse enregistrée',
      noSavedAddressButton: 'Pas d’adresse enregistrée',
      titleForSelectAddressModal: 'Sélectionnez une adresse de livraison',
      cancelButton: 'Annuler',
      submitButton: 'OK',
      useSelectButton: 'Utiliser l’adresse sélectionnée'
    },
    massUpdate: 'Utiliser pour tous les abonnements actifs',
    deleteAddressTitle: 'Supprimer l’adresse',
    updateButton: 'Mettre à jour',
    address1: 'Adresse',
    country: 'Pays',
    cancelButton: 'Annuler'
  },
  addPaymentMethod: {
    title: 'Ajouter un mode de paiement',
    instructions:
      'Un e-mail sera envoyé à {{email}} pour ajouter en toute sécurité votre mode de paiement. Confirmez ci-dessous pour envoyer l’e-mail.'
  },
  editPaymentMethod: {
    title: 'Modifier le mode de paiement',
    instructions:
      'Un e-mail sera envoyé à {{email}} pour modifier en toute sécurité votre mode de paiement. Confirmez ci-dessous pour envoyer l’e-mail.',
    shopPayInstructions: `Un e-mail sera envoyé à {{email}} pour modifier votre mode de paiement en toute sécurité dans Shop Pay. Confirmez ci-dessous pour envoyer l'e-mail. \n
    Si vous souhaitez changer de mode de paiement de Shop Pay à un autre mode de paiement, tel que PayPal ou Apple Pay, veuillez annuler votre abonnement en retournant à vos Détails d'Abonnement. Une fois annulé, créez un nouvel abonnement et saisissez le mode de paiement préféré.`
  },
  paymentMethod: {
    cancelButton: 'Annuler',
    submitButton: 'Envoyer l’e-mail',
    successTitle: 'E-mail de confirmation envoyé',
    successMessage: 'Vérifiez bientôt votre e-mail pour une confirmation'
  },
  cancelSubscription: {
    ...EnUsModalWindows.cancelSubscription,
    keepButton: 'Le Garder',
    commentsPlaceholder: 'Décrivez le problème',
    cancelButton: 'Annuler l’abonnement',
    reasons:
      'Je n’ai remarqué aucun bénéfice,Je déménage ou je voyage,J’en ai déjà assez,J’ai une raison médicale,C’est trop cher,Je n’aime pas le goût,Je ne veux pas d’abonnement,Autre raison',
    v53Reasons: 'Je n’aime pas la nouvelle formule,Je n’aime pas la nouvelle saveur tropicale',
    agzCancelationReasons:
      "Je n’aime pas le goût de l’AGZ,Je n’ai remarqué aucun avantage de l’AGZ,J'ai déjà plus d'AGZ que nécessaire,Je ne veux pas d’abonnement,J'ai une raison médicale,C'est trop cher,Je déménage pour voyager,Autre raison",
    commentsLabel: 'Commentaires',
    keepSubscriptionButton: 'Garder l’abonnement',
    text: 'Confirmez l’annulation de votre abonnement ci-dessous. Si vous souhaitez donner une raison, nous serions heureux de recevoir vos commentaires pour améliorer l’expérience pour d’autres à l’avenir (facultatif) :',
    title: 'Nous sommes désolés que vous partiez !'
  },
  cancelSubscriptionEuUk: {
    reasons: {
      common: {
        noBenefit: {
          label: 'Je n’ai remarqué aucun bénéfice',
          streak: 'Votre série : <strong>{{days}} jours d’AG1</strong>',
          description: {
            lessThan90Days:
              'De nombreux membres déclarent ressentir pleinement les bienfaits après 90 jours d’utilisation quotidienne régulière. Continuez encore un peu votre routine AG1.',
            moreThan90Days:
              'Nos études cliniques montrent que plus vous utilisez AG1 longtemps, plus les bienfaits s’accumulent.'
          },
          btnFullBenefits: 'Bénéfices complets AG1',
          btnClinicalStudies: 'Études cliniques'
        },
        movingOrTraveling: {
          label: 'Je déménage ou je voyage',
          description:
            'Changez l’adresse de livraison pour votre prochaine commande ou passez aux sachets de voyage.',
          btnChangeShipAddress: 'Changer l’adresse de livraison',
          btnSwitchToTravelPacks: 'Passer aux sachets de voyage'
        },
        alreadyHaveMore: {
          label: 'J’en ai déjà plus qu’il m’en faut',
          description:
            'Mettez votre abonnement en pause ou ajustez la fréquence de livraison pour mieux correspondre à vos besoins.',
          btnPauseSubscription: 'Pause 1 mois',
          btnEditFrequency: 'Modifier la fréquence'
        },
        medicalReason: {
          label: 'J’ai une raison médicale'
        },
        tooExpensive: {
          label: 'C’est trop cher',
          description:
            'AG1 simplifie votre routine quotidienne et vous fait économiser de l’argent car il remplace de nombreux autres produits.',
          btnQualityStandards: 'Notre qualité & normes'
        },
        dontLikeTaste: {
          label: 'Je n’aime pas le goût',
          description:
            'Pour de meilleurs résultats, ajoutez AG1 à de l’eau fraîche, et vous pouvez ajouter plus d’eau pour diluer la saveur. Découvrez ci-dessous quelques astuces simples pour rendre AG1 plus agréable à boire.',
          btnSeeRecipes: 'Voir les recettes'
        },
        dontWantSubscription: {
          label: 'Je ne veux pas d’abonnement',
          description:
            'En vous abonnant à AG1, vous payez {{symbolCurrency}}20 de moins par sachet et bénéficiez d’une livraison gratuite et pratique selon votre planning. Vous avez également accès à des produits réservés aux membres.',
          btnPauseSubscription: 'Pause 1 mois',
          btnEditFrequency: 'Modifier la fréquence'
        },
        otherReason: {
          label: 'Autre raison'
        }
      }
    },
    commentsInputPlaceholder: 'Commentaires (facultatif)',
    question: 'Pourquoi annulez-vous votre abonnement AG1 ?'
  },
  switchProduct: {
    packName: 'Pochettes de voyage',
    modalTitle: 'Passer à {{productName}}',
    title:
      'Votre prochaine commande du {{formatNextOrderDate}} contiendra {{qtyModal}} boîte(s) de {{switchToText}}',
    infoMessage: 'Le produit ne sera changé que pour votre prochaine commande.',
    cancelButton: 'Annuler',
    confirmButton: 'Confirmer',
    pouchName: 'Sachets',
    quantityText: 'Quantité de {{switchToText}} à changer :',
    description:
      'Vous pouvez modifier la quantité de vos {{switchToText}} sur la page de gestion des abonnements.'
  },
  switchFromFreeShipping: {
    text: 'Votre plan actuel de livraison gratuite nécessite un stock de 3 mois d’AG1 Pouch expédié tous les 90 jours. En passant aux sachets de voyage, le prix reviendra à 89 € pour 30 sachets et des frais de livraison de 9 € par commande.'
  },
  skipShipment: {
    textConfirm: 'La prochaine date de commande sera modifiée au {{date}}',
    skipButton: 'Annuler',
    questionConfirm: 'Êtes-vous sûr de vouloir sauter la prochaine expédition ?',
    continueButton: 'Continuer',
    headConfirm: 'Sauter l’expédition'
  },
  acceptAddressValidation: {
    title: 'Confirmez votre adresse',
    continueButton: 'Enregistrer et continuer',
    enteredTitle: 'Adresse saisie',
    editButton: 'Modifier l’adresse',
    suggestedTitle: 'Adresse suggérée',
    text: 'Nous n’avons pas pu vérifier exactement l’adresse que vous avez saisie. Veuillez vérifier si elle est correcte ou apporter les modifications nécessaires.'
  },
  shopAlert: {
    deleteButtonTitle: 'Continuer',
    cancelButtonTitle: 'Annuler',
    makeGiftCartButtonTitle: 'En tant que cadeau',
    subToGift: {
      headerTitle: 'Avant d’ajouter un abonnement',
      content:
        'Les commandes cadeaux ne peuvent contenir que des produits expédiés une seule fois. En ajoutant un abonnement à votre panier, les produits cadeaux seront supprimés.'
    },
    giftToSub: {
      headerTitle: 'Avant d’ajouter un cadeau',
      content:
        'Les commandes d’abonnement ne peuvent pas être envoyées avec un message cadeau. En ajoutant un cadeau à votre panier, les produits d’abonnement seront supprimés.'
    },
    giftToOtp: {
      headerTitle: 'Voulez-vous faire de toute la commande un cadeau ?',
      content:
        'Vous avez déjà des produits en achat unique dans votre panier. Voulez-vous faire de toute la commande un cadeau ?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Produit ajouté à la prochaine commande de ',
    toastSubscription: 'Produit ajouté à {{name}}',
    toastSeveralSubscription: 'Produit ajouté à',
    severalSubscriptions: 'abonnements',
    toastToAllSubscription: 'Produit ajouté à tous les abonnements',
    toastToAllNextOrder: 'Produit ajouté à la prochaine commande de tous les abonnements',
    titleSubscription: 'Ajouter un produit à l’abonnement',
    titleNextOrder: 'Ajouter un produit à la prochaine commande',
    checkbox: 'Ajouter à tous les abonnements actifs',
    text: 'Sélectionnez l’abonnement auquel vous souhaitez ajouter le produit.',
    addProductButton: 'Ajouter le produit'
  },
  cart: {
    subscriptionTitle: 'Abonnement',
    title: 'Votre panier',
    checkoutButtonLabel: 'Passer à la caisse',
    summary: {
      taxEstimatedLabel: 'Taxe estimée',
      taxLabel: 'Taxe',
      totalLabel: 'Total',
      taxNotReady: '---',
      shippingLabel: 'Expédition',
      discountLabel: 'Votre réduction',
      freePrice: 'Gratuit',
      subtotalLabel: 'Sous-total'
    },
    emptyState: {
      oneTimeProductsTitle: 'Favoris des membres',
      addOneTimeProductButton: 'Ajouter au panier',
      label: 'Ajoutez des articles à votre panier'
    },
    emptyStateLabel: 'Ajoutez des articles à votre panier',
    frequencyLabel: 'Expédié tous les 30 jours',
    promoCode: {
      promoCTA: 'Avez-vous un code promo ?',
      promoError: 'Le code promo est invalide',
      promoInputLabel: 'Code promo',
      promoButtonLabel: 'Appliquer'
    }
  },
  changeOrderDate: {
    title: 'Sélectionnez la date de commande',
    confirmButton: 'Confirmer',
    nextOrderDateSuccessText: 'Votre prochaine date de commande est {{date}}.',
    nextOrderDateChangeText:
      'La prochaine date de commande pour cet abonnement sera modifiée au {{date}} ',
    description: 'La date de la prochaine commande peut être repoussée jusqu’à 60 jours plus tard.',
    newDateChangeText: 'La prochaine date de commande est',
    newDateSuccessText: 'La prochaine date de commande a été modifiée au {{date}} '
  },
  shipNow: {
    shipNowButton: 'Confirmer la commande',
    subtitle: 'Commande passée avec succès',
    description:
      'Cette commande sera expédiée dans les 24 heures (L-V) après paiement. Prévoir jusqu’à 48 heures pendant le week-end et les jours fériés. Votre prochaine commande sera passée dans {{shipInterval}} le {{date}}',
    title: 'Expédier la prochaine commande maintenant',
    confirm:
      'En confirmant ci-dessous, votre commande sera traitée dans un délai d’un jour ouvrable. Prévoir jusqu’à 48 heures pendant le week-end et les jours fériés.',
    preparing: 'Préparation en cours',
    preparingDescription: 'Vous avez une commande en cours qui devrait être expédiée',
    shipped: 'Expédié',
    shippedDescription: 'Vous avez une commande en cours qui a été expédiée',
    delivered: 'Livré',
    deliveredDescription: 'Votre dernière commande a été livrée',
    shipNext: 'Expédier la prochaine commande maintenant :',
    nextOrder: 'Prochaine commande :',
    followedBy: 'Suivi de :'
  },
  editFrequency: {
    titleView: 'Modifier la fréquence d’expédition',
    titleDatepicker: 'Modifier la date de la prochaine commande',
    day: 'Jour',
    infoMessage: 'La fréquence d’expédition a été modifiée au {{date}}.',
    shippingFrequency: 'Fréquence d’expédition',
    item: 'Tous les',
    nextOrderButton: 'Prochaine date de commande',
    nextOrderLink: 'Modifier la prochaine date de commande',
    nextOrder: 'Prochaine commande :',
    followedBy: 'Suivi de :',
    description: 'Les modifications prendront effet à partir de votre prochaine date de commande.',
    followingText: 'suivi de',
    ribbonMessage:
      'Cette modification ne s’applique qu’aux commandes <bold>{{followingText}}</bold> après votre prochaine date de commande.',
    extraInfo:
      'En confirmant ci-dessous, vous serez facturé aujourd’hui et la commande sera expédiée dans un délai d’un jour ouvrable. Prévoir jusqu’à 48 heures pendant le week-end et les jours fériés.',
    saveButton: 'Enregistrer les modifications',
    confirmButton: 'Confirmer'
  },
  acceptChanges: {
    text: 'La mise à jour des informations de votre abonnement réinitialisera votre prochaine commande et supprimera les articles "à usage unique".',
    title: 'Avant de modifier votre abonnement',
    continueButton: 'Continuer',
    cancelButton: 'Annuler'
  },
  acceptFreeShippingChanges: {
    text: 'Votre plan actuel de livraison gratuite nécessite un stock de 3 mois de produit, expédié tous les 90 jours. En modifiant la quantité, le prix reviendra à 79 € par sac et des frais de livraison de 9 € par commande.',
    title: 'Avant de modifier votre abonnement',
    continueButton: 'Continuer',
    cancelButton: 'Annuler',
    successMessage:
      'Votre abonnement est désormais à 79 € par sac avec des frais de livraison de 9 €'
  },
  activateSubscription: {
    successTitle: 'Votre abonnement {{name}} est actif et disponible à la gestion.',
    errorMessage: 'Impossible de modifier la date de commande',
    activateButton: 'Activer l’abonnement',
    title: 'Réactiver l’abonnement',
    infoMessage:
      'Vous pouvez modifier la date de votre prochaine commande avant que votre abonnement ne soit activé',
    successDescription: 'La prochaine date de commande est {{date}}.'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting “Add to Subscription”. Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToOrder: 'Ajouter le produit à la commande',
    addToSubscription: 'Ajouter à l’abonnement',
    addToNextOrder: 'Ajouter à la prochaine commande',
    addedToNextOrder: 'Ajouté à la prochaine commande',
    addedToSubscription: 'Ajouté à l’abonnement',
    preferredFlavorText: 'Member preferred flavor'
  },
  addToSubscriptionFromPdp: {
    modalHeader: 'Votre abonnement',
    ships: 'Ships',
    shipsEvery: 'Expédié tous les {{count}} jours',
    manageSubscription: 'Gérer l’abonnement',
    continueShopping: 'Continuer les achats',
    saving: 'Enregistrement...',
    productSubtotal: 'Sous-total du produit',
    taxesEstimated: 'Taxes estimées après enregistrement',
    createNewSubscription: 'Create New Subscription'
  }
};
